import a from "unist-builder";

function e() {
  return (e = Object.assign || function (a) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var t in n) {
        Object.prototype.hasOwnProperty.call(n, t) && (a[t] = n[t]);
      }
    }

    return a;
  }).apply(this, arguments);
}

var n = "cell",
    t = "row";

function o() {
  var a = [].slice.call(arguments),
      e = a[0],
      n = a[1],
      t = a[2],
      o = [],
      r = {};
  return Array.isArray(n) ? o = n : (o = t || [], r = n instanceof Object ? n : {
    value: n
  }), [e, r, o];
}

export default function r() {
  var i = o.apply(void 0, [].slice.call(arguments)),
      c = i[0],
      l = i[1],
      u = i[2];

  switch (c) {
    case "table":
      var s = l.data,
          d = l.position,
          p = [],
          v = 0;
      return u.forEach(function (a) {
        switch (a ? a.type : void 0) {
          case t:
            p.push(r(t, e({}, a, {
              index: v
            }), a.children)), v++;
        }
      }), a("table", {
        data: s,
        position: d
      }, p);

    case t:
      var f = l.data,
          x = l.index,
          h = l.position,
          b = [],
          y = x,
          m = 0;
      return u.forEach(function (a) {
        var t = a instanceof Object ? a : {
          value: a
        };

        switch (a ? a.type : void 0) {
          case "column":
            b.push(r("column", e({}, t, {
              index: m
            }))), m++;
            break;

          case n:
          case void 0:
            b.push(r(n, e({}, t, {
              columnIndex: m,
              rowIndex: y
            }))), m++;
        }
      }), a(t, {
        data: f,
        index: x,
        position: h
      }, b);

    case n:
      var w = l.columnIndex,
          I = l.data,
          O = l.position,
          j = l.rowIndex,
          g = l.value;
      return a(n, {
        columnIndex: w,
        data: I,
        position: O,
        rowIndex: j,
        value: g
      });

    case "column":
      var A = l.data,
          E = l.dataType,
          T = l.index,
          k = l.label,
          P = l.position,
          q = l.value;
      return a("column", {
        data: A,
        dataType: E,
        index: T,
        label: k,
        position: P,
        value: q
      });

    default:
      return a("table", []);
  }
}